import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Tag } from '@nusign/picflow-backend-types';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';

@Component({
  selector: 'app-asset-tag-list',
  templateUrl: './asset-tag-list.component.html',
  styleUrls: ['./asset-tag-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, ButtonDirective, TooltipDirective],
})
export class AssetTagListComponent {
  tags = input.required<Tag[]>();
  canEditTag = input.required<boolean>();
  clickable = input<boolean>(false);
  lightBackground = input<boolean>(false);
  clicked = output<{ tag: Tag; event: Event }>();
  remove = output<{ tag: Tag; event: Event }>();
}
